import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=f2a173a2&scoped=true&"
import script from "./AccountSettings.vue?vue&type=script&lang=ts&"
export * from "./AccountSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a173a2",
  null
  
)

export default component.exports